
import { Head } from 'vite-react-ssg';
import { Mail } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import NavigationButtons from '@/components/NavigationButtons';

const Contact = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "The Independent DeepSeek Guide",
    "url": "https://deepseek.ai/contact",
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "info@deepseek.ai",
      "contactType": "editorial",
      "areaServed": "Worldwide",
      "availableLanguage": ["English"]
    }
  };

  return (
    <>
      <Head>
        <title>Contact The Independent DeepSeek Guide</title>
        <meta name="description" content="Contact the team behind The Independent DeepSeek Guide about corrections, the Chrome extension or content suggestions. We are not DeepSeek and cannot help with DeepSeek accounts." />
        <meta name="keywords" content="contact, Independent DeepSeek Guide, corrections, Chrome extension" />
        <link rel="canonical" href="https://deepseek.ai/contact" />
        
        <meta property="og:title" content="Contact The Independent DeepSeek Guide" />
        <meta property="og:description" content="Corrections, extension questions or content suggestions for this independent DeepSeek guide." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://deepseek.ai/contact" />
        <meta property="og:image" content="https://deepseek.ai/og-image.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact The Independent DeepSeek Guide" />
        <meta name="twitter:description" content="Corrections, extension questions or content suggestions for this independent DeepSeek guide." />
        <meta name="twitter:image" content="https://deepseek.ai/og-image.png" />
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Head>

      <div className="min-h-screen pt-20 bg-gradient-to-br from-blue-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Contact The Independent DeepSeek Guide</h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Spotted an error in a guide, have a question about our Chrome extension, or want to suggest a topic?
              Email us.
            </p>
            <p className="mt-4 text-sm text-gray-500 max-w-2xl mx-auto">
              We are an independent site and are not DeepSeek. We cannot help with DeepSeek accounts, logins, billing
              or API keys. For those, contact DeepSeek through{" "}
              <a href="https://www.deepseek.com" target="_blank" rel="noopener noreferrer" className="underline">deepseek.com</a>.
            </p>
          </div>

          <NavigationButtons />

          <div className="max-w-lg mx-auto">
            <Card className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6 text-center">
                <Mail className="w-12 h-12 text-deepseek-primary mx-auto mb-4" />
                <h2 className="text-xl font-semibold mb-2">Email Us</h2>
                <a 
                  href="mailto:info@deepseek.ai" 
                  className="text-gray-600 hover:text-deepseek-primary transition-colors"
                >
                  info@deepseek.ai
                </a>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
